import { Component } from '@angular/core';

@Component({
  selector: 'twaice-fe-side-nav-layout',
  templateUrl: './side-nav-layout.component.html',
  styleUrls: ['./side-nav-layout.component.scss'],
  standalone: false,
})
export class SideNavLayoutComponent {}
